import { Question } from "../question/question";

export const surveyQuestionsData: Question[] = [
    {
        id: "gender",
        title: "Gender",
        options: ["Male", "Female", "Other"],
        style: "pills",
    },
    {
        id: "ageRange",
        title: "Age range",
        options: [
            "Under 14",
            "15-19",
            "20-24",
            "25-29",
            "30-34",
            "35-39",
            "40-44",
            "45-49",
            "50-54",
            "55-59",
            "60-64",
            "65 and over",
        ],
        style: "radio",
    },
    {
        id: "location",
        title: "Location",
        options: [
            "Greater Sydney",
            "Hunter",
            "Wollongong",
            "North Coast",
            "South Coast",
            "Northen NSW (inland)",
            "Southern NSW (inland)",
            "Western NSW",
            "Another Australian state or territory",
            "Outside of Australia",
        ],
        style: "pills",
    },
    {
        id: "frequentActivity",
        title: "Most frequent waterway activity",
        options: [
            "Boating",
            "Paddling",
            "Sailing",
            "Tow Sports (e.g. wakeboarding, water-skiing)",
            "Personal Watercraft (e.g. jet skis)",
            "Not a regular waterway user",
        ],
        style: "radio",
    },
];
